const samplingRetests = [
    {
        "uuid": "1",
        "appNo": "A21122703",
        "appType": "initial",
        "phase": "assessmentReview",
        "activity": "assessmentReview_S10",
        "customerNo": "00001",
        "customerName": "中農粉絲有限公司",
        "assessmentPlace": "台東廠",
        "sampleInfos":[
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualifiedDetected",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "samplingInstruction":"於廠內連續批次生產時，可指為一個批次生產產品中抽取的一個單位 包裝或一次採樣盛裝量"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"01"},{testItem:"03", details:["0301","0303"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "samplingInstruction":"於廠內連續批次生產時，可指為一個批次生產產品中抽取的一個單位 包裝或一次採樣盛裝量"
            }
        ],
        "retestSampleInfos":[
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "samplingInstruction":"於廠內連續批次生產時，可指為一個批次生產產品中抽取的一個單位 包裝或一次採樣盛裝量"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"01"},{testItem:"03", details:["0301","0303"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "samplingInstruction":"於廠內連續批次生產時，可指為一個批次生產產品中抽取的一個單位 包裝或一次採樣盛裝量"
            }
        ],
    }
]

export default samplingRetests;